import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../projects";

export const FETCH_DATA_PROJECTS_STATUS_REQUEST = 'FETCH_DATA_PROJECTS_STATUS_REQUEST';
export const FETCH_DATA_PROJECTS_STATUS_SUCCESS = 'FETCH_DATA_PROJECTS_STATUS_SUCCESS';
export const FETCH_DATA_PROJECTS_STATUS_FAILURE = 'FETCH_DATA_PROJECTS_STATUS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataProjectsStatusRequest = () => {
    return {
        type: FETCH_DATA_PROJECTS_STATUS_REQUEST,
    };
};

const fetchDataProjectsStatusSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_PROJECTS_STATUS_SUCCESS,
        payload: data
    };
};

const fetchDataProjectsStatusFailure = (error: any) => {
    return {
        type: FETCH_DATA_PROJECTS_STATUS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataProjectsStatusRequest());
        try {
            const response = await Find('projectStatus', query, page, pageSize);
            console.log("projectStatusState", response);
            dispatch(fetchDataProjectsStatusSuccess(
                response.data
            ));

        } catch (error: any) {
            dispatch(fetchDataProjectsStatusFailure(error.message));
        }
    };
};
